import { useThemeStore } from '../stores/theme.store'
import type { ThemeMode, ResolvedTheme } from '../theme/theme.types'

interface UseThemeReturn {
  /** The computed active theme ('light' | 'dark'). */
  resolvedTheme: ResolvedTheme
  /** Whether dark mode is currently active. Convenience boolean. */
  isDark: boolean
  /** The user's explicit in-app preference ('light' | 'dark'). */
  mode: ThemeMode
  /** Change the user's preference. Persists to MMKV. */
  setMode: (mode: ThemeMode) => void
}

/**
 * Single hook for all theme needs in components.
 *
 * Components that only render dark: classes don't need this hook at all.
 * Use this hook when you need isDark for non-Tailwind logic (e.g., image src, icon color).
 */
export function useTheme(): UseThemeReturn {
  const mode = useThemeStore((s) => s.mode)
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme)
  const setMode = useThemeStore((s) => s.setMode)

  return {
    resolvedTheme,
    isDark: resolvedTheme === 'dark',
    mode,
    setMode,
  }
}
